import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query';
import { toApiQueryError } from '../apiQueryError';
import type { ApiQueryError } from '../apiQueryError';
import { getNodeSuggestions } from './suggestionsApi';
import type {
  GetNodeSuggestionsParams,
  NodeSuggestion,
} from './suggestionsApi';

export const suggestionsQueryApi = createApi({
  reducerPath: 'suggestionsApi',
  baseQuery: fakeBaseQuery<ApiQueryError>(),
  // Suggestions can change when approved flowsheets change. Keep this pilot's
  // unused cache short-lived; callers can also explicitly force a refresh.
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getNodeSuggestions: builder.query<
      NodeSuggestion[],
      GetNodeSuggestionsParams
    >({
      async queryFn(params, { signal }) {
        try {
          return { data: await getNodeSuggestions(params, signal) };
        } catch (error) {
          return { error: toApiQueryError(error) };
        }
      },
    }),
  }),
});
